import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { SxProps, Theme } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { QuestionMarkOutlined as QuestionMarkIcon } from '../../icons/question-mark-outlined';

interface Props {
  sx?: SxProps;
  text?: string;
}

const ResourceUnavailableRoot = styled('div')(({ theme }: { theme: Theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.neutral[100],
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(3),
}));

export const ResourceUnavailable = ({ text, ...other }: Props) => {
  const { t } = useTranslation('common');

  return (
    <ResourceUnavailableRoot {...other}>
      <QuestionMarkIcon sx={{ color: 'text.secondary' }} />
      <Typography color="textSecondary" sx={{ mt: 2 }} variant="body2">
        {text ? text : t('noData')}
      </Typography>
    </ResourceUnavailableRoot>
  );
};
